import { render, staticRenderFns } from "./ClientsTableExpansion.vue?vue&type=template&id=2c18424a&scoped=true&"
import script from "./ClientsTableExpansion.vue?vue&type=script&lang=js&"
export * from "./ClientsTableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./ClientsTableExpansion.vue?vue&type=style&index=0&id=2c18424a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18424a",
  null
  
)

export default component.exports